// extracted by mini-css-extract-plugin
export var container = "howToBuyEthh-module--container--tPCJx";
export var title = "howToBuyEthh-module--title--yTMJm";
export var formattedText = "howToBuyEthh-module--formattedText--+q2+0";
export var link = "howToBuyEthh-module--link---ODzu";
export var contractAddress = "howToBuyEthh-module--contractAddress--NwCv8";